import styled from "styled-components";

export const Container = styled.div`
  padding: 200px 150px;
  display: block;
  background-size: cover;
  background-position: center;

  @media (max-width: 768px) {
    padding: 60px 20px;
    text-align: center;
  }
  
  p {
    text-align: right;
    color: var(--white);
    padding-right: 200px;

    @media (max-width: 768px) {
      font-size: 0.95rem;
    }
  }
`;

export const Text = styled.div`
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    align-items: center;
  }

  h2 {
    color: var(--white);
    font-size: 48px;
    font-weight: 700;
    margin-bottom: 25px;

    @media (max-width: 768px) {
      font-size: 32px;
    }
  }

  p {
    text-align: justify;
    color: var(--white);
    margin-bottom: 25px;

    @media (max-width: 768px) {
      font-size: 0.95rem;
    }
  }

  ul {
    margin-left: 20px;
    margin-bottom: 25px;
    color: var(--white);
  }

  li {
    margin-bottom: 10px;
  }
`;

export const WrapperData = styled.div`
  text-align: right;
  max-width: 800px;
  margin: 0 auto;
`;